import FormControl from "../control";

class Input extends FormControl {
    init(element) {
        this.setRootElement(element);

        if (!!this.element) {
            this.type = 'select';
            this.validationType = 'select';

            super.init();
        }
    }

    setRootElement(element) {
        this.element = element || document.querySelector('.js-select');
    }
}

export default Input;